import { AloftDate, AloftPrice, isDefined } from '@aloft/toolkit-shared';
import { MLSListing, getC1ContractDate } from '@aloft/toolkit-shared';

import MLSDataColumn from './MLSDataColumn';
import MLSDataInfoSection from './MLSDataInfoSection';
import MLSDataValueWithLabel from './MLSDataValueWithLabel';

// placeholder while we sort out real data
const getDateString = (val?: string) =>
  val ? AloftDate.fromIsoString(val).format('MM/dd/yyyy') : '';

const MLSListingInformation = ({ listingData }: { listingData: MLSListing }) => (
  <MLSDataInfoSection title="Listing">
    <MLSDataColumn>
      {/* Hiding ListDate for now due to some weirdness with C1 OnMarketDate */}
      {/* <MLSDataValueWithLabel
                value={getDateString(
                    orUndefined(AloftDate.toIsoString)(getC1ListDate(listingData, true))
                )}
                label="List Date"
            /> */}
      <MLSDataValueWithLabel
        value={getDateString(getC1ContractDate(listingData, true)?.toIsoString())}
        label="Contract Date"
      />
      <MLSDataValueWithLabel value={getDateString(listingData.CloseDate)} label="Close Date" />
      <MLSDataValueWithLabel value={listingData.CumulativeDaysOnMarket} label="CDOM" />
      <MLSDataValueWithLabel value={listingData.DaysOnMarket} label="DOM" />
      <MLSDataValueWithLabel value={listingData.PropertySubType} label="Property Sub-Type" />
      <MLSDataValueWithLabel value={listingData.BuyerFinancing} label="Financing" />
    </MLSDataColumn>
    <MLSDataColumn>
      <MLSDataValueWithLabel value={listingData.MlsStatus} label="Status" />
      <MLSDataValueWithLabel
        value={AloftPrice.fromNumericPrice(listingData.OriginalListPrice ?? 0).toString(true)}
        label="Original List Price"
      />
      <MLSDataValueWithLabel
        value={
          isDefined(listingData.ListPrice)
            ? AloftPrice.fromNumericPrice(listingData.ListPrice).toString(true)
            : '-'
        }
        label="List Price"
      />
      <MLSDataValueWithLabel
        value={
          isDefined(listingData.ClosePrice)
            ? AloftPrice.fromNumericPrice(listingData.ClosePrice).toString(true)
            : '-'
        }
        label="Final Sale Price"
      />
      <MLSDataValueWithLabel value={listingData.PropertyType} label="Property Type" />
    </MLSDataColumn>
  </MLSDataInfoSection>
);

export default MLSListingInformation;
